module.exports = __webpack_public_path__ + "img/30_pourcent.0ae38417.png";